/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  hasAccessTo,
  roleNamesToNumber,
  userAdminLandingPage,
  userSuperAdminLandingPage,
} from 'services/roles-services'
import ROLES from 'utils/__enums/Common/ROLES'
import ROUTES from 'utils/ROUTES'

export default async function handleNavigation(
  roleNames: string[],
  history: any
) {
  const impersonateMode = sessionStorage.getItem('impersonate_mode')
  // tarnslate roles to numbers
  const userManager = userAdminLandingPage(roleNames)
  const superAdmin = userSuperAdminLandingPage(roleNames)
  const redirectionPath = localStorage.getItem('redirectTo')
  if (redirectionPath) {
    localStorage.removeItem('redirectTo')
    history.push(redirectionPath)
  } else if (userManager && !impersonateMode) {
    history.push(ROUTES.UsersManagement)
  } else if (superAdmin && !impersonateMode) {
    history.push(ROUTES.SuperAdminUsersManagement)
  } else {
    history.push(ROUTES.Dashboard)
  }
}

export const handleDocumentNavigation = (userRoles: string[]): string => {
  if (
    hasAccessTo(
      [ROLES.ROLE_CLI_BILLING, ROLES.ROLE_INT_BILLING],
      roleNamesToNumber(userRoles)
    )
  ) {
    return ROUTES.DocumentsBilling
  }
  if (
    hasAccessTo(
      [ROLES.ROLE_CLI_ACTIVITIES, ROLES.ROLE_INT_ACTIVITIES],
      roleNamesToNumber(userRoles)
    )
  ) {
    return ROUTES.DocumentsActivities
  }
  return ROUTES.DocumentsOthers
}
